import { DistributorTradePricing } from 'elements/hardwareSelectorV2/HardwareSelectorCore'
import { orgSelectors } from 'ducks/orgs'
import { LEGACY_CUSTOM_DISTRIBUTORS } from 'opensolar-common/src/services/types/hardware'
import { useGetSupplierConfig } from 'pages/ordering/hooks/useGetSupplierConfig'
import { HardwareSupplierFilterKeyType } from 'pages/ordering/type'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const shouldShowDistributorPricing = (
  distributor: string | undefined,
  distributorTradePricing: DistributorTradePricing
) => {
  if (!distributor || !distributorTradePricing) {
    return false
  }
  // Has public pricing so always show it.
  if (distributor === 'city_plumbing') {
    return true
  }

  if (LEGACY_CUSTOM_DISTRIBUTORS.includes(distributor)) {
    return distributorTradePricing[distributor]
  }
  return true
}

const useDistributorTradePricing = ({
  orgId,
  distributors,
}: {
  orgId: number
  distributors: HardwareSupplierFilterKeyType[]
}) => {
  const org = useSelector(orgSelectors.getOrg)
  const { getSupplierConfig } = useGetSupplierConfig()
  const enabledSellerIntegrations = useSelector(orgSelectors.getEnabledSellerIntegrationsConfig)

  const distributorTradePricing = useMemo(() => {
    const map: DistributorTradePricing = {}
    const outletEnabled = !!org?.enable_outlet_integration

    for (const distributor of distributors) {
      const filterKey = getSupplierConfig(distributor)?.filterKey ?? ''
      if (!filterKey) continue

      if (filterKey === 'outlet') {
        map[filterKey] = outletEnabled
      } else if (filterKey === 'segen') {
        map[filterKey] = false
      } else {
        map[filterKey] = true
      }
    }
    return map
  }, [distributors, org?.enable_outlet_integration, org?.id, orgId, getSupplierConfig, enabledSellerIntegrations])

  // Loading was previously tied to the distributors_trade_pricing request; callers must not rely on spinners here.
  const isChecking = false

  return { distributorTradePricing, isChecking }
}

export default useDistributorTradePricing
